import { wsBridge, wsStore, wsUserId } from "@/shared/api/websocket"
import { easyMatchKeys } from "../model/keys"

export function registerEasyMatchSync(): void {
	wsStore.on("state", ({ isConnected }) => {
		if (!isConnected) return
		const { queryClient } = wsBridge.getContext()
		const userId = wsUserId()
		if (!queryClient || !userId) return
		queryClient.invalidateQueries({ queryKey: easyMatchKeys.status(userId) })
	})
}
